import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Pipe({
  name: 'spellCheck'
})
export class SpellCheckPipe implements PipeTransform {

  constructor(private commonUtilty: CommonUtilty,
    private sanitizer: DomSanitizer
  ) { }

  transform(value: any): any {

    let spellCheckResult = this.commonUtilty.spellCheck(value)
    if (this.commonUtilty.isArrayIterable(spellCheckResult.wrongWords) && !environment.production)
      return spellCheckResult.wrongWords && spellCheckResult.wrongWords.length > 0 ? spellCheckResult.toolTip : null;
  }

}
